const formMeta = {
    formAction: '',
    iscompleted: false,
}

export const prefeasibilityDefaultValues = {
    project_status_and_readiness: {
        current_development_phase: '',
        readiness_for_procurement: '',
        regulatory_approvals_status: [],
        other_regulatory_approval: '',
        stakeholder_engagement_status: '',
        procurement_readiness: '',
        regulatory_readiness: '',
        stakeholder_readiness: '',
        ...formMeta,
    },

    implementation_readiness: {
        imple_timeline_planning_start: null,
        imple_timeline_planning_end: null,

        imple_timeline_procurement_start: null,
        imple_timeline_procurement_end: null,

        imple_timeline_delivery_start: null,
        imple_timeline_delivery_end: null,

        imple_timeline_operational_start: null,
        imple_timeline_operational_end: null,

        key_constraints: [],
        // Figma SG3 starts the Delivery Model Confidence slider at 60%.
        delivery_model_confidence_score: 60,
        ...formMeta,
    },

    stakeholder_and_communication_readiness: {
        investor_engagement_status: '',
        community_participation_status: '',
        government_coordination_level: '',
        ...formMeta,
    },

    risk_and_quality_gate: {
        ...formMeta,
    },
    economic_and_commercial_viability: {
        value_for_money_assessment: '',
        summary_vfm_findings: '',
        benefit_analysis: '',
        summary_benefit_findings: '',
        risk_evaluation_and_contingent_liability: '',
        summary_risk_findings: '',
        economic_multipliers_and_macroeconomic_benefits: '',
        summary_economic_multiplier_findings: '',
        economies_of_scale: '',
        summary_economies_of_scale_findings: '',
        cost_effectiveness_assessment: '',
        summary_cea_findings: '',
        social_economic_assessment: '',
        summary_social_economic_findings: '',
        ...formMeta,
    },
    options_identification_and_screening: {
        justification_of_option: {},
        ...formMeta,
    },
    demand_and_needs_validation: {
        current_demand_units: '',
        future_demand_horizon_year: '',
        population_served: '',
        growth_rate: '',
        peak_capacity_required: '',
        demand_confidence_level: '',
        ...formMeta,
    },
    cba_cea_intelligence: {
        // The required inputs start empty: a 0 default would pass "required" without any input.
        capital_cost: '',
        annual_operating_cost: '',
        economic_benefits: '',
        social_benefits: '',
        residual_value: '',
        discount_rate: '',
        analysis_period_years: '',
        cost_per_beneficiary: 0,
        cost_per_household: 0,
        cost_per_service_unit: 0,
        cost_per_job_created: 0,
        cost_per_kilometre: 0,
        cost_per_outcome_achieved: 0,
        ...formMeta,
    },
    risk_and_sensitivity_analysis: {
        capex_scenario: '',
        demand_scenario: '',
        inflation_scenario: '',
        revenue_scenario: '',
        schedule_delay_months: '',
        ...formMeta,
    },
    documents: {
        documents: [],
        ...formMeta,
    },
    approval_submit: {
        ...formMeta,
    },
    stage_gate_decision_panel: {
        ...formMeta,
    }

}

export type IPrefeasibilityFormValues =
    typeof prefeasibilityDefaultValues